module.exports = __webpack_public_path__ + "img/Z82_18.106dc345.jpg";